import { Component, Input } from '@angular/core';
import { FormulaireService } from 'src/app/saisie/formulaire.service';
import { LibellesService } from 'src/app/core/libelles.service';
import { InputComponent } from '../input/input.component';
import { FiltreService } from '../../filtre.service';
import { ModeRenduService } from 'src/app/saisie/mode-rendu/mode-rendu.service';

@Component({
  selector: 'bis-float-mask-input',
  templateUrl: './float-mask-input.component.html',
  styleUrls: ['../input/input.component.css']
})
export class FloatMaskInputComponent extends InputComponent {
  @Input()
  maskFormat: string = 'separator.2';
  @Input()
  separatorLimit: string = '999';
  @Input()
  decimalMarker: string = '.';  
  @Input()
  classeSupplInput: string = '';

  constructor(
    protected formulaireService: FormulaireService,
    protected libelleService: LibellesService,
    protected filtreService: FiltreService,
    public modeRenduService: ModeRenduService
    ) {
     super(formulaireService, libelleService, filtreService, modeRenduService);
   }
}